import React from 'react'
import ConfirmButton from '../ConfirmButton'
import ViewButton from '../ViewButton'
import RejectButton from '../RejectButton'
import { Badge } from 'react-bootstrap'
import EnrollmentDocumentsApi from '../../api/EnrollmentDocumentsApi'

const api = new EnrollmentDocumentsApi();

const AdminValidateButtons = ({ file, slug, controlNumber, setFile, nss }) => {
  return (
    <div>
      { 
        !file || 'updated_at' in file === false || file.tiene_documento === false
        ? <>
          <ConfirmButton apiCallback={() => api.accept(controlNumber, slug)} setFile={setFile} documento={file}/>{' '}
          <RejectButton apiCallback={(reason) => api.reject(controlNumber, slug, reason)} setFile={setFile} documento={file}/>
          <div>
            <Badge variant="primary">Sin subir Documento</Badge>
          </div>
        </>
          :  <>
              <ViewButton nss={nss} slug={slug} path={`/inscripcion/${controlNumber}/documentos/${slug}/ver`} />{' '}
              <ConfirmButton apiCallback={() => api.accept(controlNumber, slug)} setFile={setFile} documento={file}/>{' '}
              <RejectButton apiCallback={(reason) => api.reject(controlNumber, slug, reason)} setFile={setFile} documento={file}/>
            </>
      }
    </div>
  )
}

export default AdminValidateButtons